import React from 'react';
import { CardHeader, Typography } from '@mui/material';
import { Container, styled } from '@mui/system';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import StyTextBadge from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Result/components/KeysIndicators/components/StyTextBadge';
import { useTranslation } from 'react-i18next';

const StyCardHeader = styled(CardHeader)({
    display: 'flex',
});

const CardHeaderTitle = (
    startDate: SimulationDateString,
    isPastYear: boolean, // if today is past the year displayed
    year: number,
): React.ReactElement => {
    const { t } = useTranslation();
    const startYear = parseInt(startDate.slice(0, 4), 10);
    const currentYear = new Date().getFullYear();

    const isStartYear = startYear === year;
    const displayToolTip = // if the year displayed is over or the last year is over
        isPastYear || (year > startYear && currentYear > startYear);
    const proposalHeaderSubtitle =
        currentYear > year ? 'evolutionAvailable' : 'evolutionInProgress';
    return (
        <Container
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '0 !important',
            }}
        >
            <Typography variant="h5">
                {t(
                    `humanResources.simulation.keysIndicators.${
                        isStartYear ? 'projection' : 'budgetProposal'
                    }`,
                )}
            </Typography>

            {displayToolTip && (
                <StyTextBadge
                    title={t(
                        `humanResources.simulation.keysIndicators.${
                            isStartYear
                                ? 'evolutionAvailable'
                                : proposalHeaderSubtitle
                        }`,
                        {
                            year,
                            lastYear: year - 1,
                        },
                    )}
                />
            )}
        </Container>
    );
};
type Props = {
    startDate: SimulationDateString;
    isPastYear: boolean;
    year: number;
};
const ResultItemHeader = ({ startDate, isPastYear, year }: Props) => (
    <StyCardHeader
        titleTypographyProps={{ variant: 'h5' }}
        title={CardHeaderTitle(startDate, isPastYear, year)}
    />
);
export default ResultItemHeader;
